import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';
import { CountTable } from '../interfaces/count_table';
import { BASEURL } from '../constant/url';
import { Operations } from '../interfaces/operation';

@Injectable({
  providedIn: 'root',
})
export class StatsService {
  private readonly _http = inject(HttpClient);

  fetchCountTable(): Observable<CountTable> {
    return this._http.get<CountTable>(`${BASEURL}stats/count-tables`).pipe(catchError(this.handleError));
  }

  fetchOperations(): Observable<Operations[]> {
    return this._http.get<Operations[]>(`${BASEURL}stats/operations-by-month`).pipe(catchError(this.handleError));
  }

  private handleError = (error: HttpErrorResponse) => {
    let errorMessage = 'Error en el servicio de Estadísticas.';
    if (error.error && error.error.error && error.error.error.message) {
      errorMessage = error.error.error.message;
    } else if (error.message) {
      errorMessage = error.message;
    }
    console.error('StatsService error:', errorMessage, error.error || error);
    return throwError(() => new Error(errorMessage));
  }
}
